<template>
  <section class="production">
    <header>
      <h2>{{production.title}}</h2>
      <p class="subtitle">
        {{production.subtitle}}
      </p>
    </header>
    <div class="container production-en">
      <div class="production-layout">
        <div class="production-layout__photo">
          <img v-lazy="require('../../../static/images/product/diarybook-3.png')" alt="Book production">
        </div>
        <div class="production-layout__timeline">
          <div class="production-badge">7 <span>DAYS</span></div>
          <div class="production-steps">
            <div class="production-steps__line"></div>
            <div class="production-step" v-for="(step, idx) in steps" :key="idx">
              <div class="production-step__dot"></div>
              <span class="production-step__label">{{ step }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Production',
  props: {
    production: Object
  },
  computed: {
    ...mapGetters(['language']),
    isEn () {
      return this.language === 'en'
    },
    steps () {
      return [
        this.$t('products.productionOrder'),
        this.$t('products.productionPrint'),
        this.$t('products.productionBind'),
        this.$t('products.productionQC'),
        this.$t('products.productionPack'),
        this.$t('products.productionShip')
      ]
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
.production-en {
  .production-layout {
    display: flex;
    align-items: center;
    max-width: 960px;
    margin: 0 auto;
    gap: 2rem;

    &__photo {
      flex: 0 0 45%;
      border-radius: 12px;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    &__timeline {
      flex: 1;
      text-align: center;
    }
  }

  .production-badge {
    font-size: 4rem;
    font-weight: 800;
    color: lighten($el-color-primary, 30%);
    line-height: 1;
    margin-bottom: 1.5rem;

    span {
      font-size: 1.5rem;
      display: block;
      letter-spacing: 0.2em;
    }
  }

  .production-steps {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    padding: 0 0.5rem;

    &__line {
      position: absolute;
      top: 8px;
      left: 1rem;
      right: 1rem;
      height: 3px;
      background: linear-gradient(to right, $el-color-primary, lighten($el-color-primary, 30%));
      z-index: 0;
    }
  }

  .production-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: relative;
    z-index: 1;

    &__dot {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: $el-color-primary;
      border: 3px solid lighten($el-color-primary, 30%);
    }

    &__label {
      font-size: 0.8125rem;
      font-weight: 600;
      color: #374151;
      white-space: nowrap;
    }
  }
}

@media (max-width: 768px) {
  .production-en {
    .production-layout {
      flex-direction: column;
      gap: 1.5rem;

      &__photo {
        flex: none;
        width: 100%;
      }

      &__timeline {
        width: 100%;
      }
    }

    .production-badge {
      font-size: 2.5rem;
      margin-bottom: 1rem;
      span {
        font-size: 1rem;
      }
    }

    .production-steps {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 0;
      padding: 0;

      &__line {
        top: 8px;
        left: 8%;
        right: 8%;
      }
    }

    .production-step {
      &__dot {
        width: 14px;
        height: 14px;
      }
      &__label {
        font-size: 0.6875rem;
        text-align: center;
      }
    }
  }
}
</style>
